module.exports = __webpack_public_path__ + "img/bg3_OneStore.8dc795ce.png";